export default "__VITE_ASSET__78e1328d__"